import { render, staticRenderFns } from "./ModalMultOrderDetail.vue?vue&type=template&id=140bc67c"
import script from "./ModalMultOrderDetail.vue?vue&type=script&lang=js"
export * from "./ModalMultOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports